import React, { useRef, useState } from 'react';
import { MoreHorizontal } from 'lucide-react';
import Tooltip from '../ui/Tooltip';
import ContextMenu from '../ui/ContextMenu';

/**
 * The "…" of the detail card: the rarely used actions (copy the repository
 * address, a team's move / remove, stop tracking), so the everyday ones —
 * Sync now, Pull, Open — stand alone. The app's own ContextMenu, opened under
 * the button and right-aligned with it. Nothing to offer → no button.
 *
 * @param {{ items: Array<{ icon?, label: string, onClick: () => void, disabled?: boolean, danger?: boolean }|false|null> }} props
 */
export default function GitMoreMenu({ items, disabled = false }) {
  const [at, setAt] = useState(null);
  const ref = useRef(null);
  const shown = (items || []).filter(Boolean);
  if (!shown.length) return null;

  const open = () => {
    const r = ref.current?.getBoundingClientRect();
    setAt(r ? { x: r.right, y: r.bottom + 4 } : { x: 0, y: 0 });
  };

  return (
    <>
      <Tooltip content="More" side="bottom">
        <button
          ref={ref}
          type="button"
          className="git-btn git-btn--icon"
          aria-label="More actions"
          aria-haspopup="menu"
          aria-expanded={Boolean(at)}
          disabled={disabled}
          onClick={open}
        >
          <MoreHorizontal size={15} />
        </button>
      </Tooltip>
      {at && <ContextMenu x={at.x} y={at.y} align="end" items={shown} onClose={() => setAt(null)} />}
    </>
  );
}
